import React, { ReactNode } from "react";
import styled from "styled-components";
import { shorten } from "@backpacker/number";
import TooltipContent from "@charty/tooltip";
import { FontWeight } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { parse } from "@tootools/emoji";
import SafeHTML from "@ui-kit/safe-html";
import Tooltip from "@ui-kit/tooltip";

const Root = styled.span<{
  normalizedWeight: number;
  onClick: () => void;
}>`
  margin: 2px 6px;
  cursor: ${(props) =>
    props.onClick ? "var(--cursor-magic-wand)" : "default"};
  font-weight: ${FontWeight.Normal};
  font-size: ${(props) => props.normalizedWeight * 100}%;
  opacity: ${(props) => props.normalizedWeight};
  :hover {
    opacity: 1;
  }

  img.emoji {
    height: 8em;
    width: 8em;
    margin: 0 1em;
  }
`;

interface IProps {
  weight: number;
  label: string;
  isHidden?: boolean;
  normalizedWeight: number;
  locale: Locale;
  onClick?: () => void;
  tooltip?: (serie: { label: string; weight: number }) => ReactNode;
  animated?: boolean;
}

const CloudEmoji = ({
  label,
  normalizedWeight,
  tooltip,
  locale,
  weight,
  onClick,
  animated,
}: IProps) => (
  <Tooltip
    disabled={animated}
    tooltip={
      tooltip ? (
        tooltip({ label, weight })
      ) : (
        <TooltipContent
          label={<SafeHTML as="span" html={parse(label)} />}
          content={shorten(locale, weight)}
        />
      )
    }
  >
    <Root
      dangerouslySetInnerHTML={{ __html: parse(label) }}
      normalizedWeight={normalizedWeight}
      onClick={onClick}
    />
  </Tooltip>
);

export default CloudEmoji;
